import { useNavigate, useParams } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { FormGroup, Card, PageHeader, Button } from "@cofano/cck";
import Grid from "@mui/material/Grid2";

import Helmet from "components/helmet/Helmet";

import { Language, usePermission } from "imports/Utils";

import GasolineStaffelItemsTable from "./components/tables/GasolineStaffelItemsTable";
import { StaffelTabs } from "./utils/StaffelUtils";

import { GetStaffelDocument } from "__generated__/view/staffels/graphql/staffel.queries.generated";

const GasolineStaffelDetails = () => {

	const navigate = useNavigate();
	const { id } = useParams();

	const { isAdmin, isMasterdata, isReadOnly } = usePermission();

	const { data, loading } = useQuery(GetStaffelDocument, {
		variables: {
			id: Number(id),
		},
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("GASOLINE_STAFFEL")}
					<Helmet title={intl.formatMessage({ id: "GASOLINE_STAFFEL" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					<Button onClick={() => navigate(`/view/staffels?tab=${StaffelTabs.GASOLINE}`)} variant="outlined">
						{Language("STAFFELS")}
					</Button>

					{((isAdmin || isMasterdata) && !isReadOnly) && (
						<Button onClick={() => navigate(`/view/staffels/${id}/edit/gasoline`)}>
							{Language("EDIT")}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Grid spacing={3} container>
				<Grid size={6}>
					<Card>
						<FormGroup label={intl.formatMessage({ id: "DESCRIPTION" })} labelPlacement="left-center" overflow="hidden">
							{data?.staffel?.description}
						</FormGroup>

						<GasolineStaffelItemsTable
							content={data?.staffel?.staffelItems ?? []}
							contentLoading={loading} />
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

export default GasolineStaffelDetails;
